export default {
	PHONECALLS_COLUMN_DATE: 'Date',
	PHONECALLS_COLUMN_DATE_FROM: 'Date from',
	PHONECALLS_COLUMN_DATE_TO: 'Date to',
	PHONECALLS_COLUMN_RINGING_DURATION: 'Ringing duration',
	PHONECALLS_COLUMN_TALKING_DURATION: 'Talking duration',
	PHONECALLS_COLUMN_DIRECTION: 'Direction',
	PHONECALLS_COLUMN_PHONE_NUMBER: 'Phone number',
	PHONECALLS_COLUMN_IS_ANSWERED: 'Answer',
	PHONECALLS_COLUMN_PHONE_DESCRIPTION: 'Phone title',
	PHONECALLS_COLUMN_PHONE_ITEM: 'Linked item',
	PHONECALLS_COLUMN_PHONE_PERSON: 'Person',
	PHONECALLS_COLUMN_PHONE_IMPORT_TYPE: 'Imported from',
	PHONECALLS_COLUMN_PHONE_CALL_USER: 'User',

	PHONECALLS_ACTIONS_VIEW_NOTES: 'View Notes',
	PHONECALLS_ACTIONS_ADD_PERSON: 'Add Person',
	PHONECALLS_ACTIONS_ADD_COMPANY: 'Add Company',
	PHONECALLS_ACTIONS_ADD_PHONE: 'Add Phone Number',
	PHONECALLS_ACTIONS_ADD_ACTIVITY: 'Add Activity',
	PHONECALLS_DIALOG_VIEW_NOTES: 'Notes',

	PHONECALLS_DIRECTION_INCOMING: 'Incoming',
	PHONECALLS_DIRECTION_OUTGOING: 'Outgoing',
	PHONECALLS_COUNT_IN: 'Incoming',
	PHONECALLS_COUNT_OUT: 'Outgoing',

	PHONECALLS_CHART_TOTAL_PHCA_DURATION: 'Total: {value}',
	PHONECALLS_CHART_TOTAL_PHCA_DURATION_IN: 'Total Incoming: {value}',
	PHONECALLS_CHART_TOTAL_PHCA_DURATION_OUT: 'Total Outgoing: {value}',

	PHONECALLS_CHART_NO_COMPANY: 'No company',

	PHONECALLS_CHART_TITLE: 'Phone calls during the year',
	PHONECALLS_PIECHART_COMPANIES_TITLE: 'Phone calls by Company',
	PHONECALLS_PIECHART_DIRECTION_TITLE: 'Phone Calls by Direction',

	DETAILS_PHONECALLS_FIELD_TITLE: 'Title',
	DETAILS_PHONECALLS_FIELD_COMPANIES: 'Company',
	DETAILS_PHONECALLS_FIELD_DATE_FROM: 'Date',
	DETAILS_PHONECALLS_FIELD_USER: 'User',
	DETAILS_PHONECALLS_FIELD_PERSON: 'Person',
	DETAILS_PHONECALLS_FIELD_ANSWERED: 'Call made'
};
